export const getTimeuuid = (survey) => {
	return typeof survey === 'string' ? survey : survey?.timeuuid;
}

export const forceArray = (arr) => {
	if (arr instanceof Array) {
		return arr;
	}

	return [arr];
}

export const toTimeuuids = surveys => forceArray(surveys).map(s => getTimeuuid(s));
